import { RadioGroup } from '@headlessui/react';
import { forwardRef, useEffect, useRef } from 'react';
import type { Option } from '../../../../types/Form';
import InputError from '../Error';
import styles from '../Form.module.css';

export interface RadioGroupInputProps {
  value: any;
  label?: string;
  renderLabel?: React.ReactNode;
  name?: string;
  onChange: (value: any) => void;
  onBlur?: (value: any) => void;
  className?: string;
  disabled?: boolean;
  options?: Option[];
  error?: string;
  hasOthers?: boolean;
  id?: string;
}
const RadioGroupInput = forwardRef<HTMLDivElement, RadioGroupInputProps>((props: RadioGroupInputProps, ref) => {
  const { value, onChange, disabled, label, renderLabel, options, error, hasOthers, name, id, className = '', onBlur } = props;
  const others = value && options?.findIndex((opt) => opt.value === value) === -1;

  const inputRef = useRef<HTMLInputElement | null>(null);
  useEffect(() => {
    if (others && inputRef.current && inputRef.current.value === '') {
      inputRef.current.value = value;
    }
  }, [others, value]);

  return (
    <div className={`flex flex-col ${className} `}>
      <RadioGroup
        ref={ref}
        value={value}
        id={id}
        onChange={(value) => {
          onChange(value);
          if (inputRef.current) {
            inputRef.current.value = '';
          }
        }}
        disabled={disabled}
      >
        {(renderLabel !== undefined || label !== undefined) && (
          <RadioGroup.Label className={'leading-7 block text-sm font-medium text-neutralColor-medium'} htmlFor={id}>
            {renderLabel || label}
          </RadioGroup.Label>
        )}
        <div className='flex gap-6 mt-2'>
          {options?.map(({ label, value }, index) => (
            <RadioGroup.Option value={value} key={value} id={`${id}-${value}-${index}`} className='shrink-0 cursor-pointer'>
              {({ checked }) => (
                <div className='flex items-start space-x-2'>
                  <input type='radio' checked={checked} className='mt-1' onBlur={onBlur} />
                  <span>{label}</span>
                </div>
              )}
            </RadioGroup.Option>
          ))}
          {hasOthers && (
            <div className='flex items-start gap-x-2  cursor-pointer'>
              <div className='flex items-center gap-x-2'>
                <input type='radio' checked={others} id={`${id}-others`} />
                <span>Others:</span>
              </div>
              <input
                name={name}
                ref={inputRef}
                id={`${id}-others-input`}
                type='text'
                className={`${styles['form-input-min-normal']}`}
                onChange={(e) => {
                  onChange(e.target.value);
                }}
              />
            </div>
          )}
        </div>
      </RadioGroup>
      {error && <InputError>{error}</InputError>}
    </div>
  );
});

export default RadioGroupInput;
